import { render } from "./AboutView.vue?vue&type=template&id=7481974f&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=7481974f&scoped=true&lang=css"

import exportComponent from "C:\\Source\\LETC\\LETC_VueRouterWeb\\letc_vr_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7481974f"]])

export default __exports__